export enum LoadingStatusType {
    isLoading = 'loading',
    isLoaded = 'loaded',
    isError = 'error'
}
